import { render, staticRenderFns } from "./fontsettings.vue?vue&type=template&id=2fbff77a"
import script from "./fontsettings.vue?vue&type=script&lang=js"
export * from "./fontsettings.vue?vue&type=script&lang=js"
import style0 from "./fontsettings.vue?vue&type=style&index=0&id=2fbff77a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports